import React, { FC } from 'react'

import { FeaturedPhotosPromoX3 } from 'components/block/FeaturedPhotosPromoX3/FeaturedPhotosPromoX3'
import { useFeaturedPhotosPromoX3 } from 'components/block/FeaturedPhotosPromoX3/hooks/useFeaturedPhotosPromoX3'
import { GuaranteeViews } from 'components/presentational/svg/GuaranteeViews'

export const FeaturedPhotoIconSwitch: FC = () => {
  const { isFeaturedPhotosPromoX3Active } = useFeaturedPhotosPromoX3()
  return isFeaturedPhotosPromoX3Active ? (
    <FeaturedPhotosPromoX3 size="XS" />
  ) : (
    <GuaranteeViews width="100%" />
  )
}
